import FondationsApiModel from 'models/global/FondationsApiModel';

export default class NewFondationsApiModel extends FondationsApiModel {
	public patch(attributes: object = {}, options: object = {}) {
		return this.save({
			...options,
			method: 'patch',
			patchAttributes: attributes,
			headers: {
				// @ts-ignore
				...options.headers,
				'Content-Type': 'application/merge-patch+json',
			}
		});
	}
}
